import { get } from 'lodash';
import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';
import { MarketplaceId } from '@rome/request/marketplace/MarketplaceId';
export var ProductServiceabilityActions;
(function (ProductServiceabilityActions) {
    ProductServiceabilityActions["REQUEST"] = "PRODUCT_SERVICEABILTY_REQUEST";
    ProductServiceabilityActions["ERROR"] = "PRODUCT_SERVICEABILTY_ERROR";
    ProductServiceabilityActions["SUCCESS"] = "PRODUCT_SERVICEABILTY_SUCCESS";
})(ProductServiceabilityActions || (ProductServiceabilityActions = {}));
export function fetchProductServiceability(productId, pincode, showSuperTitle, marketplace = MarketplaceId.FLIPKART) {
    return (dispatch) => {
        const productServiceability = {
            requestContext: { marketplace, products: [{ productId }] },
            locationContext: { pincode },
            showSuperTitle
        };
        dispatch({
            type: ProductServiceabilityActions.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers,
            credentials: 'include',
            acceptErrors: true,
            pathname: `/api/3/product/serviceability`,
            action: ProductServiceabilityActions.REQUEST
        }), productServiceability).then(json => {
            const response = get(json, ['RESPONSE', productId]);
            return dispatch({
                type: ProductServiceabilityActions.SUCCESS,
                data: response
            });
        }, error => {
            const errorMessage = get(error, ['RESPONSE', 'errorMessage'], '');
            return dispatch({
                type: ProductServiceabilityActions.ERROR,
                errorMessage
            });
        });
    };
}
